import React from "react";
import Home from "../pages/Home";
import Page from "./Page";

export default function HomeContainer(props: any) {
    return (
        <Page Body={Home} />
    )
}